<div id="cA-DD-loginBoxContent" *ngIf="pageNotFound" class="container">
    <div id="cA-DD-login-box-center-content" class="center hide">
    </div>
    <div id="cA-DD-content" class="cA-DD-innerContent container">
        <section id="main">
            <h1>Oops! Page Not Found</h1>
            <p>We're sorry, the page you're looking for no longer exists. Try the links below or sign on to <a
                    id="cmlink_MainCreditCardsLink" href="/credit-cards/" target="_top">citi.com/creditcards</a> if
                you're already a cardmember.</p>
            <div class="errorblocks">
                <div><a id="cmlink_ViewAllCreditCardsLink" href="/credit-cards/view-all-credit-cards"
                        target="_top" title="View All Credit Cards">View All Credit Cards &gt;</a>
                    <p>You can view and compare features for all Citi® Credit Cards to decide which is best for you.
                        Instantly compare up to 3 credit cards side by side.</p>
                </div>
                <div><a id="cmlink_LandingPageKnowledgeCenterLink"
                        [href]="environmentPath + '/credit-cards/knowledge-center'" title="Citi Credit Knowledge Center"
                        target="_top">Citi Credit Knowledge Center &gt;</a>
                    <p>The more you know about credit, the better you can manage it. Visit the Knowledge Center for
                        bite-size credit tips that make a big difference.</p>
                </div>
                <div><a id="cmlink_BalanceTransferCreditCardsLink"
                        href="/credit-cards/balance-transfer-credit-cards" title="Balance Transfer Credit Cards"
                        target="_top">Balance Transfer Credit Cards &gt;</a>
                    <p>A balance transfer may allow you to move existing balances from a high interest card to a credit
                        card with a low intro APR on balance transfers. Explore and compare some of Citi's best credit
                        cards.</p>
                </div>
                <div><a id="cmlink_SiteMapLink" href="/credit-cards/sitemap" title="Site Map" target="_top">Site Map
                        &gt;</a>
                    <p>Access the Site Map for a directory of the website.</p>
                </div>
            </div>
        </section>
    </div>
</div>